export default {
  // actions:
  add: "Add",
  cancel: "Cancel",
  delete: "Delete",
  edit: "edit",
  exit: "Exit",
  filter: "Filter",
  import: "Import",
  goBack: "Go back",
  logout: "Logout",
  next: "Next",
  previous: "Previous",
  return: "Return",
  save: "Save",
  search: "Search",
  signIn: "Login / Sign up",
  sortBy: "Sort by",
  upload: "upload",
  validate: "Validate",
  yes: "Yes",
  No: "No",
  others: "Others",

  // messages:
  // [Info]
  contentModelDescription:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation",
  dragMessage: "Drag and drop a file here, or click to select file to upload.",
  dropMessage: "Drag and drop to change the order of the tabs",
  importInProgress: "- Timesheet's import in progress, hang on please ...",
  importTimeSheet: "Import of time-sheet's the organization",
  notifUpdates: "Notifications of updates",
  nothingFound: "Nothing Found",
  nothingToShow: "Nothing to show",
  noCollaboratorsMatches: "No result fetched.",
  noBudget: "No budget is imported for this organization.",
  noTimeSheet: "No timesheet is imported for this organization.",
  noTimeSheetMatches: "No timesheet matches your filter values!",
  noFinancialSheetMatches: "No financial sheet matches your filter values!",
  noOrganization: "Current organization is not activated.",
  searchNameorVATNumber: "Search by name or VAT number",
  defaultDialogMessage: "Do you want to proceed ?",
  typesNoCategories: "Task Types non-categorized",
  selectCategoriesMessage: "Deselect to exclude categories.",
  searchMessageCategories: "Tap a category to assign it to your selection",
  searchMessageValuations: "Tap a valuation to assign it to your selection",
  chooseMessageCategories:
    "Select items to assign categories or classifications to them",
  deleteCategoriesTitle: "Dissociation confirmation",
  deleteCategoriesMessage:
    "Are you sure you want to unlink this type from actual category?",
  confirmationDeleteCategoryMessage:
    "Are you sure you want to delete this category?",
  confirmationDeleteSuperCategoryMessage:
    "Are you sure you want to delete this super category?",
  confirmationDeleteAnalysisPlanMessage:
    "Are you sure you want to delete this analysis plan?",
  confirmationDeleteValuationMessage:
    "Are you sure you want to delete this classification ?",
  confirmationDeleteCategoryTitle: "Confirmation of deletion",
  confirmationOverwriteTitle: "Confirmation of overwrite",
  confirmationForcedDeleteCategoryMessage: "Do you want to force the deletion?",
  confirmationForceDeleteCategoryTitle: "Delete error",
  attentionArrivalDate:
    "The statistics are calculated from the employee's arrival date ",
  confirmationForceUpdateCategoryTitle: "Update error",
  confirmationForcedUpdateCategoryMessage:
    "Are you sure you want to overwrite the billablity of associeted task-type ?",
  attentionDepartureDate:
    "The statistics are calculated to the employee's departure date",
  attentionWorkingDates:
    "The statistics are calculated from the employee's arrival date to hir deparute one",
  validatePreviousLevels: "validate first two levels to unlock this one",

  // [Confirmation]
  confirmationDeleteRoleTitle: "Confirmation of deletion",
  confirmationDeleteRoleMessage: "Do you want to remove the role?",
  confirmationDeleteZoneTitle: "Confirmation of deletion",
  confirmationDeleteZoneMessage: "Do you want to remove the zone?",
  confirmationDeleteBuTitle: "Confirmation of deletion",
  confirmationDeleteBuMessage: "Do you want to remove the BU?",
  confirmationDeleteRegimeTitle: "Confirmation of deletion",
  confirmationDeleteRegimeMessage: "Do you want to remove the regime?",
  confirmationCategoriesTitle: "Confirmation of award",
  confirmationCategoriesMessage:
    "Do you want to assign the category to your selection?",
  confirmDeleteTasksMessage:
    "Some tasks belonging to the date range of the file to import are already saved, do you want to overwrite them?",
  confirmationDeleteHolidayTypeTitle: "Confirmation of deletion",
  confirmationDeleteHolidayTypeMessage:
    "Do you want to remove this type of holiday?",
  // [Success]
  importSuccess: "Import successful",
  importTimeSheetSuccess: "import timesheet successful",
  operationCompleted: "action performed successfully",
  successfulAction: "Successful action",
  correlateTaskTypeSuccess: "correlation successful",
  confirmationOverWriteCategoriesMessage:
    "Do you want to over-write the distribution of actual total?",

  // [Error]
  error: "Error",
  errorOccured: "An error occured, Please retry later.",
  incorrectFile: "Imported file is incompatible !",
  incompatibleModel:
    "The imported file does not correspond to the chosen model !",
  fileSize:
    "The size of imported file is not supported, please export a file with maximum 800 lines!",
  incompleteOperation:
    "Unable to complete operation, incorrect data was submited",
  lostMessage: "You've moved so fast and got lost...",
  noResult: "Oops, No results found for your search",
  Oops: "Oups",
  pageNotFound: "This Page Could Not Be Found!",
  collaboratorNotArrivedYet:
    "the collaborator was not recruited at the selected analyse date",
  collaboratorHasLeft:
    "the collaborator has left the organization by the selected analyse date",
  collaboratorNeedConfiguration:
    "the collaborator need configuration before getting statistics",

  //Comments
  overloadCollaborator: "An overload hours for this employee of %xh",
  clientOutBudget: "With an intervention on %x files other than those budgeted",
  overloadNonBillable: "A non-billable overtime of %xh is recorded",
  almostNonBillable:
    "The non-billable pro rata account may be settled, there is %xh remaining",
  greatProgressARC:
    "A very interesting engagement with %x more hours compared to the annual budget prorata",
  acceptedProgressARC:
    "A remarkable commitment with a negligible delay of %x hours compared to the annual budget prorata",
  warningProgressARC:
    "A worrying engagement with a delay of %x hours compared to the annual budget prorata",
  alertProgressARC:
    "Almost no engagement with a delay of %x hours compared to the annual budget prorata",
  greatProgressCRC:
    "A very interesting engagement with %x more hours compared to the annual capacity prorata",
  acceptedProgressCRC:
    "A remarkable commitment with a negligible delay of %x hours compared to the annual capacity prorata",
  warningProgressCRC:
    "A worrying engagement with a delay of %x hours compared to the annual capacity prorata",
  alertProgressCRC:
    "Almost no engagement with a delay of %x hours compared to the annual capacity prorata",
  overNinety: "coefficient over 90%",
  underNinety: "coefficient under 90%",
  releasedOverUsualBillable: "Released billable exceed the usual",
  releasedUnderUsualBillable: "Released billable doesn't cover the usual",

  // Label
  chooseERP: "Choose the ERP",
  communities: "Communities",
  capacityPlaning: "Capacity planing",
  dateRange: "date range",
  endDate: "End date",
  profile: "Profile",
  settings: "Settings",
  startDate: "Start date",
  diagram: "Diagram",
  fromDate: "from",
  to: "to",
  recentActivities: "Recent activities",
  noActivities: "no activities",
  relizedDuration: "Realized time",
  folder: "Folder",
  cycleLabel: "Table diagram",
  TAMTAMApplications: "TAMTAM Applications",
  manageTasks: "Manage tasks",
  categories: "Categories",
  noCategory: "Out of category",
  noValuation: "Out of classification",
  allCategories: "All categories",
  clientGroup: "Client group",
  client: "Client",
  collaboratorList: "Collaborators List",
  collaboratorSpace: "collaborator Space",
  collaborator: "Collaborator",
  collaborators: "Collaborators",
  taskCategory: "Task category",
  periodeType: "Period type",
  datePeriod: "Date periode",
  attribution: "Attribution",
  timeAchieved: "Time achieved",
  statistics: "Statistics",
  allClients: "All clients",
  myClients: "My clients",
  otherClients: "Other clients",
  collaboratorsSettings: "collaborators setting",
  categorySettings: "category setting",
  name: "Name",
  NoAffected: "UNAFFECTED",
  regime: "Regime",
  role: "Role",
  annualCapacity: "Annual capacity",
  grade: "seniority level",
  NFHr: "Non billable Hours",
  roles: "Roles",
  regimes: "Regimes",
  basicNFH: "basic NF",
  specialProject: "NF Special project",
  nbrWeeks: "Number weeks",
  RHHebdo: "RH Hebdo",
  total: "Total",
  solde: "Credit",
  roleOnFolder: "Role on folder",
  folderManager: "Folder manager",
  asClientManager: "as client manager",
  asEncodingDelegate: "as encoding delegate",
  asSupervisor: "as supervisor",
  removeSuccess: "Remove success",
  saveSuccess: "Save success",
  rolesList: "Role list",
  typesList: "Type list",
  zonesList: "Zone list",
  busList: "BU list",
  createRole: "Create role",
  createType: "Create type",
  updateRole: "Update role",
  updateType: "Update type",
  updateZone: "Create zone",
  createZone: "Update zone",
  updateBu: "Create BU",
  createBu: "Update BU",
  roleCreated: "Role created",
  holidayTypeCreated: "Holiday type created",
  zoneCreated: "Zone created",
  buCreated: "Business unit created",
  roleUpdated: "Role updated",
  holidayTypeUpdated: "Holiday type updated",
  zoneUpdated: "Zone updated",
  buUpdated: "Business unit updated",
  roleDeleted: "Role deleted",
  holidayTypeDeleted: "Holiday type deleted",
  zoneDeleted: "Zone deleted",
  buDeleted: "Business unit deleted",
  regimesList: "Regime list",
  createRegime: "Create regime",
  updateRegime: "Update regime",
  regimeCreated: "Regime created",
  regimeUpdated: "Regime updated",
  regimeDeleted: "Regime deleted",
  collaboratorUpdated: "collaborator updated",
  arrivalDate: "arrival date",
  departureDate: "departure date",
  selectDate: "select a date",
  selectZone: "select a zone",
  selectBu: "select a bu",
  selectRole: "select a role",
  selectRegime: "select a regime",
  selectProfile: "select a profile",
  selectPartner: "Select a partner",
  enterSpecialProject: "entre special project",
  title: "Title",
  dossierCount: "Client count",
  configBudget: "manage Budget",
  setBudgetGlobal: "enter the total budget",
  budgeted: "Budgeted",
  nonBudgeted: "Non-budgeted",
  remainingBudget: "Budget remaining to be allocated",
  hrForWeek: "Hours per week",
  hrForYear: "Hours per year",
  AssociatedWith: "Associated with",
  classified: "Classified",
  BelongsTo: "Belongs to",
  nonBillableAdmittedQP: "NBA prorata",
  annualAffectedBudgetQP: "AAB prorata",
  realAffectedBudgetQP: "real budget prorata",
  analyseDate: "Analyse date",
  usualBillable: "Expected billable",
  billable: "Real billable",
  usualNonBillable: "Allowed non-billable",
  nonBillable: "Real non-billable",
  spreadPositive: "Spread+",
  spreadNegative: "Spread-",
  involvement: "involvement",
  clearing: "Clearing",
  shortfall: "Shortfall",
  shortage: "Shortage",
  diffNonBillable: "Difference non-billable",
  localisation: "localization",
  businessUnit: "Business unit",
  zones: "Zones",
  zone: "Zone",
  bu: "BU",
  squad: "Squad",
  baseOn: "base on",
  clonerFrom: "clone from",
  forYear: "for the year",
  selectRegimeMessage: "Please select a regime",
  desactivateDelegation: "Deactivate the delegation and reset the budget",
  activateDelegation: "Activate the delegation",
  addNewDelegated: "add new delegated collaborator",
  cloneSuccess: "clone successfull",
  budgetCloned: "Budget cloned",
  topfolders: "Top folders",
  flopfolders: "Flop folders",
  topprogressions: "Top progressions",
  flopprogressions: "Flop progressions",
  effectiveBenchmark: "effective benchmark",
  normalizedBenchmark: "normalized benchmark",
  remainingHours: "Remaining hours",
  realizedHours: "Realized Hours",
  extraTimeSuccess: "Interesting extraTime",
  extraTimeWarning: "Warning extraTime",
  extraTimeDanger: "Critical extraTime",
  affectedBudget: "Affected budget",
  realizedBudget: "Realized budget",
  extraBudget: "Extra-Budeget",
  nonBillableHours: "Non-billable",
  billableHours: "billable",

  // Titles
  Caution: "Caution",
  budget: "Budget",
  productionCapacityPlanning: "Production capacity planing",
  clientList: "liste des clients",
  detailedBudget: "Detailed Budget of :",
  toDate: "to date",
  MyTimeSheet: "Time sheet",
  taskTypesSettings: "Tasks setting",
  subTitleCapacityPlanningProduction: "VUE CAPACITY PLANING GÉNÉRAL",
  subTitleTimeSheet: "DETAILED FINANCIAL HEALTH VIEW",
  subTitleBudgetSheet: "DETAILED FORECAST HEALTH VIEW",
  subTitleClientList: "Visualize and manage your customer files",
  subTitleCategoryStatistics: "Incenderat autem audaces usque ad insaniam",
  titleModalRegime: "Create or edit regimes",
  titleModalHolidayType: "Create or edit type of holidays",
  titleModalRole: "Create or edit roles",
  titleModalLocalization: "Create or edit localizations params",
  UpdateCollaboratorSettingTitle: "Collaborator's settings",
  UpdateCollaboratorSetting: "Manage collaborator's settings",
  ProfilCollaboratorSetting: "Collaborator's profil",
  manageBudget: "Manage the budget :",
  manageBudgetClient: "Manage budget dossier",
  budgetSettingOf: "Budget configuration for: ",
  KPIEvaluation: "KPI Evaluation",
  KPIBudgetaire: "KPI Budgetary",
  budgetSetting: "Budget setting",
  budgetedFolders: "[est attribué]",
  handledFolders: "[intervient]",
  notifyUsingUa:
    "Warning: This link will no longer be functional. Please login via this link: ",
  // Enumeration
  ACTIVATED: "ACTIVATED",
  DEACTIVATED: "DEACTIVATED",
  NOT_CONFIGURED: "[NON CONFIGURÉ]",
  PENDING: "Pending",
  READY: "[PRÊT]",

  CLIENT_GROUP: "Client group",
  CLIENT: "Client",
  TASK_TYPE: "Prestation type",
  COLLABORATOR: "Collaborator",

  french: "French",
  english: "English",
  dutch: "Dutch",

  month: "month",
  quarter: "quarter",
  semester: "semester",
  year: "year",

  today: "Today",
  yesterday: "Yesterday",
  otherday: "Otherday",
  week: "Week",

  monthly: "Monthly",
  current: "Current",
  annual: "Annual",

  CapacityAnnual: "Capacity annual",
  NonBillableAdmitted: "Non billable admitted",
  AnnualAffectedBudget: "Annual affected budget",
  OutBudgetCompletion: "Completion off budget",
  BudgetaryAvailability: "Budgetary availability",
  CapacityAnnualQP: "State of capacity annual",
  NonBillableSaved: "State of non billable saved",
  AnnualReleasedCompletion: "Annual released completion",
  CurrentReleasedCompletion: "Current released completion",
  BillableCoefficient: "Current billable coefficient",
  BillableNFCoefficient: "NF coefficient",
  attachedClients: "Attached Clients",
  tasksList: "Tasks list",
  assignCategorie: "Assign tasks to categories",
  categoriesList: "Categories list",
  addCategories: "Add your categories",
  manageCategories: "Manage categories",
  frenchTitle: "French Title",
  coefficient: "Coefficient",
  englishTitle: "English Title",
  dutchTitle: "Dutch Title",
  addCategory: "Add a category",
  addAnalysisPlan: "Add a analysis plan",
  addSuperCategory: "Add a super category",
  categoryAdded: "Category added",
  ValuationAdded: "Classification added",
  categoryUpdated: "Category updated",
  ValuationUpdated: "Classification updated",
  categoryDeleted: "Category deleted",
  ValuationDeleted: "Classification deleted",
  typeTitleCategory: "Type the title of your category (3 languages available)",
  typeTitleAnalysisPlan:
    "Type the title of your analysis plan (3 languages available)",
  typeTitleSuperCategory:
    "Type the title of your super category (3 languages available)",
  typeTitleValuation:
    "Type the title of your assessment (3 languages available)",
  classification: "Classification",
  selectCommunity: "choose your community",
  listCommunity: "List of member communities",
  clientsPrivileges: "clients list privileges",
  accessClientList: "Allow access to clients list",
  activateNotifications: "Activate notifications",
  activateCarteNotifications: "Activate carte notifications",
  activateCalendarNotifications: "Activate calendar notifications",
  allowConfigurateBudget: "Allow budget configuration",
  allowAccessClientSpace: "Allow access to client space",
  allowAccessCollaboratorList: "Allow access to collaborator liste",
  CommunityUnauthorised:
    "This community does not have access to this application",
  "Drag and drop a picture here, or click to select picture to upload.": "",

  CLIENT_MANAGER: "Client Manager",
  ENCODING_DELEGATE: "Encoding Delegate",
  RESPONSIBLE: "Responsible",
  DELEGATED: "Delegated",
  allFiles: "All files",
  myFolders: "Files as Responsible",
  otherFolders: "Files as Delegate",
  tableView: "Table view",
  graphicView: "Chart view",
  Categories: "Categories",
  SuperCategories: "Super Categories",
  AnalysesPlan: "Analyses Plan",
  SuperCategory: "Super category...",
  AnalysisPlan: "Analysis Plan...",
  WorkingHoursPerDay: "Working hours per day",
  NumberOfDays: "Number of days",
  OvertakingHours: "Attention you have an Overtaking of: ",
  TimeLeft: "Number of hours remaining to be allocated: ",

  collaboratorNotLinkedToAnyZone: "Collaborator not linked to any zone.",
  pleaseAssignHimAZoneBeforeSettingUpHisCalendar:
    "Please assign him a zone before setting up his calendar.",
  pleaseConfigureTheCompanysAnnualCalendarBefore:
    "Please configure the company's annual calendar before.",
  AnnualCalendarNotFound: "Annual calendar not found.",
  calendarSettings: "Calendar Settings",
  holidays: "Holidays",
  annualHolidays: "Annual holidays",
  workingDays: "Working days",
  paidVacations: "Paid vacations",
  paidVacation: "Paid vacation",
  myVacations: "My vacations",
  ManageTheCollaboratorsCalendar: "Manage the collaborator's calendar.",
  ManageMyCalendar: "Manage my calendar and holidays.",
  ManageTheAnnualCalendarOfYourFiduciary:
    "Manage the annual calendar of your fiduciary",
  confirmationDeleteCalendarConfigMessage:
    "Are you sure you want to delete this configuration?",
  ManageTheCollaboratorsInformation: "Manage the informations of collaborators",
  FinancialStatement: "Financial statement",
  subTitleFinancialSheet: "DETAILED FINANCIAL HEALTH VIEW",
  saveAndNext: "Save & Next",

  myCalendar: "My Calendar",
  noAnnualCalendar: "Annual calendar for the year",
  annualCalendarNotConfig: "is not yet configured",
  advancedConfig: "Advanced configuration",

  importedFrom: "Imported from",
  identifier: "identifier",
  selectCollaborator: "please select at least one collaborator",

  entiteFiltre: "Entity (clients associated with: )",

  analysis: "Analysis",
  details: "Details",
  entite: "Entity",

  clientType: "Clients type",
  attache: "Attached",
  tous: "All",
  entiteType: "Entity",

  configureClassesMessage: "Please configure the added valuations",
  analysisRealisedHours: "Analysis of realised hours for each valuation :",
  MoreDetails: "More details",

  descriptionAnnualFolder: `This table considers here the budgets and the realized on an annual basis`,
  descriptionCurrentFolder: `This table considers here the budgets and carried out on a proportional basis, that is to say taking into account a budget<br/>distributed evenly throughout the year and the current synchronization date`,

  realized: "Realized",

  globalBudgetAffected: "global Budget Affected",
  globalBudgetNotAffected: "Budget Not Affected",
  budgetByZoneAffected: "budget By Zone Affected",
  budgetZoneDelegationAffected: "budget Delegation Affected",
  budgetZoneByCategoryNotCompleted: "budget By Category Not Completed",
  delegationNotAffected: "Delegation Not Affected",
  budgetCompleted: "budget Completed",
  profit: "Revenue",
  budgetaryBenchmark: "Budgetary Benchmark",
  benchmark: "Effective Benchmark",
  sum: "Sum",
  Belgique: "Belgium",
  Maroc: "Morocco",
  effectiveRate: "Effective rate",
  budgetaryRate: "Budgetary rate",
  and: "and",
  more: "other clients ",
  globalBudgetLeft: "Global budget left",
  surpassedBudget: "You have surpassed the global budget",
  overwrittenZoneBudget: "You risk to overwrite the zone budget",
  insufficientZoneBudget: "Insufficient zone budget",
  insufficientGlobalBudget: "Insufficient global budget",
  dataDelegatedCollaboratorRequired: "Collaborator delegated data are required",

  SUPERADMIN: "Super Admin",
  ADMIN: "Administrator",
  USER: "User",
  NONE: "None",
  EDITOR: "Editor",
  LEGAL_REPRESENTATIVE: "Legal Representative",
  OFFICIAL: "Collaborator",
  EXTERNAL: "External",
  MANAGER: "Manager",
  PARTNER: "Partner",
  manager: "Manager",
  partner: "Partner",
  orphanFolders: "Orphan Folders",

  myCollaboratorSpace: "My collaborator space",

  applicationNotActivated:
    "Power Team application is not Activated for the current organization.",
  accountingNotActivated:
    "Accounting application is not Activated for the current organization.",
  applicationNotActivatedIndication:
    "Please contact us for further information.",
  about_us_content: `is a suite of tools that enable a community to communicate, share, organise or collaborate efficiently. The platform is equipped with various applications assembled as required by the customer. Thanks to our mutuality tools, our customers have the latest technologies without having to develop them and invest in their core business.`,
  totalCollaboratorFolderInfo:
    "it is possible that a collaborator works on the same folder with different roles, which means that the total is not always equal to the sum of the four folder columns.",
  budgetGlobal: "Global budget",
  affectationBudgetaire: "Budget allocation",
  budgetParCat: "Budget by Category",
  attributionBudgetaire: "Budget attribution",
  update: "Update",
  budgetUpdated: "Budget updated successfully.",
  errorUpdatingBudget: "Unknown error while updating budget.",

  parametersUpdated: "Parameters updated",
  parameterSettings: "Parameter Settings",
  parameterSettingsParameterBenchmark:
    "Activate or deactivate synchronization and manage the fiduciary setting",
  parameterBenchmark: "Manage the organization parameter",
  parameterSynchronization: "Synchronization parameter",
  parameterOrganization: "Organization parameter",
  parameterAuth: "Authorizations parameter",
  manageRolesCollaboratorsOnFiles: "Manage roles of collaborators on files",
  manageRole: "Manage Role",
  manageEntity: "Manage Entity",
  ManageClientEntityRelationships: "Manage client entity relationships",
  annualBenchmark: "Annual benchmark",
  enterAnnualBenchmark: "Enter the annual benchmark",
  messageInfoSynchronization:
    "The activation of synchronization implies that the management of Entities and / or Roles will no longer be accessible from Power Team, and to make changes you must go through your ERP.",
  messageInfoBenchmark:
    "If you do not specify this parameter, the benchmark value used by default is 70.",
  dynamicTable: "Magic Table",
  all: "All",
  unbudgeted: "Unbudgeted",
  inProgress: "In progress",
  advanced: "Advanced",
  budgetedState: "Budgeted",
  unknown: "Unknown",
  SUPERVISOR: "Supervisor",
  StatusBudgEco: "Economic budget status",
  StatusBudgHoraire: "Hourly budget status",
  budgetEcoManquant: " Unallocated economic budget",
  Export: "Export",
  Import: "Import",
  importFinancialSheet: "Import Financial Sheet",
  importFinancialSheetSuccess: "import financial sheet successful",
  importFinancialContentModelDescription:
    "please check that your excel file contains the following columns",
  SUPERVISOR_ZERO_WARNING: "Supervisor without budget",
  SUPERVISOR_NULL_WARNING: "Unassigned supervisor",
  GD_ZERO_WARNING: "GD without budget",
  GD_NULL_WARNING: "Unassigned GD",
  GE_ZERO_WARNING: "GE without budget",
  GE_NULL_WARNING: "Unassigned GE",
  SE_ZERO_WARNING: "SE without budget",
  SE_NULL_WARNING: "Unassigned SE",
  SCAN_OP_ZERO_WARNING: "Scan op without budget",
  SCAN_OP_NULL_WARNING: "Unassigned scan op",
  DELEGATION_ZERO_WARNING: "Delegate without budget",
  DELEGATION_NULL_WARNING: "Unassigned delegate",
  DELEGATION_ZONE_WARNING: "Delegate with wrong zone",
  UNBALANCED_BUDGET: "Unbalanced Budget",
  monAgenda: "My agenda",
  myBirthdays: "My birthdays",
  noEvent: "No event",
  calendrier: "Calendar",
  explorer: "Explore",
  cumulated: "cumulated",
  nonCumulated: "not cumulated",
  individual: "individual",
  collective: "collective",
  cumulate: "cumulated",
  taskTypeUpdated: "task type updated",
  isBillable: "Billable",
  individualScore: "individual score",
  collectiveScore: "collectif score",
  organizationScore: "organization score",
  REJECTED: "Rejected",
  APPROVED: "Approved",
  rejectionMessage: "Are you sure you want to reject this vacation ?",
  approvalMessage: "Are you sure you want to approve this vacation ?",
  NonBudgetise: "This client cannot be budgeted !",
  regimeVAT: "VAT Regime",
  closingDate: "Closing date",
  totalBudget: "Total budget",
  belgiumBudget: "BE Budget",
  moroccoBudget: "MO Budget",
  SCAN_OP: "SCAN OP",
  deleted: "Deleted",
  persistent: "",
  selectedRole: "Selected role",
  clientState: "Client state",
  notCollaborator: "No longer a collaborator",
  se: "Encoding supervisor",
  folderNumber: "Number of folders",
  collaboratorNumber: "Number of collaborators",
  categoryNumber: "Number of categories",
  userNumber: "Number of users",
  activate: "Activate",
  desactivate: "Desactivate",
  Budgeting: "Budgeting",
  BudgetingInProgress: "- Budgeting is underway. Please wait a moment ...",
  ALL: "All",
  priceList: "Price list",
  price: "Price",
  category: "Category"
};



// WEBPACK FOOTER //
// ./src/i18n/en.js